function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { adaptSdkAddonsClientConfig } from './adapters/addons-config-adapter/addons-config-adapter';
import { adaptSdkPlayersClientConfig } from './adapters/players-config-adapter/players-config-adapter';
import { sdkLogger } from '../logger';
import { CoreVideoConfigProvider } from './core-video-config/core-video-config-provider';
var LOCAL_CONFIG_IDENTIFIER = 'static';
export var LocalConfigProvider = /*#__PURE__*/ function() {
    "use strict";
    function LocalConfigProvider(sdkConfig, device, compiledConfigLoader) {
        _class_call_check(this, LocalConfigProvider);
        _define_property(this, "sdkConfig", void 0);
        _define_property(this, "device", void 0);
        _define_property(this, "coreVideoConfigProvider", void 0);
        _define_property(this, "sdkConfigPerPlaybackType", void 0);
        _define_property(this, "logger", void 0);
        this.sdkConfig = sdkConfig;
        this.device = device;
        this.logger = sdkLogger.withContext('Static Config Provider');
        this.sdkConfigPerPlaybackType = {
            default: this.sdkConfig
        };
        this.coreVideoConfigProvider = new CoreVideoConfigProvider(this.sdkConfig, this.device, compiledConfigLoader);
    }
    _create_class(LocalConfigProvider, [
        {
            key: "initialise",
            value: function initialise() {
                var _this = this;
                return _async_to_generator(function() {
                    var defaultConfigLoadError;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.coreVideoConfigProvider.initialise()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                defaultConfigLoadError = _state.sent();
                                _this.logger.error('Failed to load default config with error: ', defaultConfigLoadError);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getConfig",
            value: function getConfig() {
                return this.sdkConfigPerPlaybackType;
            }
        },
        {
            key: "checkHasConfigChanged",
            value: function checkHasConfigChanged(lastConfigIdentifier) {
                return lastConfigIdentifier !== LOCAL_CONFIG_IDENTIFIER;
            }
        },
        {
            key: "getFailoverReason",
            value: function getFailoverReason() {
                return 'NA';
            }
        },
        {
            key: "buildInternalConfig",
            value: function buildInternalConfig(playbackType, device) {
                var localConfig = this.sdkConfigPerPlaybackType.default;
                var defaultConfigPerPlaybackType = this.coreVideoConfigProvider.getConfig();
                var defaultConfig = defaultConfigPerPlaybackType[playbackType];
                // No playback type overrides exist in the default config
                if (!defaultConfig) {
                    return;
                }
                defaultConfig = defaultConfig || defaultConfigPerPlaybackType['default'];
                var addons = localConfig.addons, players = localConfig.players;
                var addonsConfig = adaptSdkAddonsClientConfig({
                    defaultConfig: defaultConfig.addons,
                    clientConfig: addons
                });
                var playersConfig = adaptSdkPlayersClientConfig({
                    defaultConfig: defaultConfig.players,
                    clientConfig: players
                }, device);
                var metalistConfig = _object_spread({}, localConfig.metalist, defaultConfig.metalist);
                var dynamicConfig = {
                    configMetadata: {
                        configIdentifier: LOCAL_CONFIG_IDENTIFIER,
                        configTimestamp: "".concat(Date.now()),
                        appliedDeviceMatchers: defaultConfig.configMetadata.appliedDeviceMatchers,
                        appliedPlaybackTypeOverride: defaultConfig.configMetadata.appliedPlaybackTypeOverride
                    },
                    hasExtendedDvrSupport: defaultConfig.hasExtendedDvrSupport,
                    players: playersConfig,
                    addons: addonsConfig,
                    prefetching: localConfig.prefetching,
                    preferredStreamPropertyGroups: defaultConfig.preferredStreamPropertyGroups,
                    allowedDvrWindowDurations: defaultConfig.allowedDvrWindowDurations,
                    telemetry: localConfig.telemetry,
                    csai: localConfig.csai,
                    cmcd: localConfig.cmcd,
                    performance: localConfig.performance,
                    metalist: Object.keys(metalistConfig).length ? metalistConfig : undefined,
                    reducedLatency: localConfig.reducedLatency,
                    allowedAudioCodecs: defaultConfig.allowedAudioCodecs,
                    drmOverride: defaultConfig.drmOverride
                };
                return dynamicConfig;
            }
        }
    ]);
    return LocalConfigProvider;
}();

//# sourceMappingURL=local-config-provider.js.map